// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_c3-0";
export var headerCellHover = "_c3-1";